(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/react/pages/game-package-page.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/react/pages/game-package-page.js');

'use strict';

const useWeekDrawUpdates = svs.gamePackage.hooks.useWeekDrawUpdates;
const _svs$gamePackage$redu = svs.gamePackage.redux.thunks,
  getInitialBalance = _svs$gamePackage$redu.getInitialBalance,
  pay = _svs$gamePackage$redu.pay;
const _ReactRedux = ReactRedux,
  useDispatch = _ReactRedux.useDispatch;
const _React = React,
  useEffect = _React.useEffect,
  useCallback = _React.useCallback;
const _svs$gamePackage$comp = svs.gamePackage.components,
  Hero = _svs$gamePackage$comp.Hero,
  Games = _svs$gamePackage$comp.Games,
  Payfooter = _svs$gamePackage$comp.Payfooter,
  SizePicker = _svs$gamePackage$comp.SizePicker,
  AccountSelectorContainer = _svs$gamePackage$comp.AccountSelectorContainer;
const GamePackagePage = () => {
  useWeekDrawUpdates();
  const dispatch = useDispatch();
  const _svs$gamePackage$data = svs.gamePackage.data.hero,
    images = _svs$gamePackage$data.images,
    textColor = _svs$gamePackage$data.textColor,
    heroContentList = _svs$gamePackage$data.heroContentList;
  const handlePay = useCallback(() => {
    dispatch(pay());
  }, [dispatch]);
  useEffect(() => {
    if (svs.utils.paramHandler.get({
      key: 'pay'
    }).value && !svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      svs.utils.paramHandler.remove({
        key: 'pay'
      });
      svs.utils.paramHandler.remove({
        key: 'bag'
      });
    }
    if (svs.utils.paramHandler.get({
      key: 'pay'
    }).value) {
      handlePay();
    }
    dispatch(getInitialBalance());
  }, [handlePay, dispatch]);
  return React.createElement(React.Fragment, null, images && React.createElement(Hero, {
    images: images,
    textColor: textColor,
    heroContentList: heroContentList
  }), React.createElement(SizePicker, null), React.createElement(Games, null), React.createElement(AccountSelectorContainer, null), React.createElement(Payfooter, {
    onPay: handlePay
  }));
};
svs.gamePackage.components.GamePackagePage = GamePackagePage;

 })(window);